import React from 'react';
import { CheckCircle, Award, Shield, Leaf, Heart, Clock, TrendingUp, Users, Star } from 'lucide-react';
import { Link } from 'react-router-dom';
import { CTAStrip } from '../components/CTAStrip';
const team = [{
  name: 'Marcus Johnson',
  role: 'Founder & Director',
  img: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&auto=format&fit=crop&facepad=3&fit=facearea'
}, {
  name: 'Priya Sharma',
  role: 'Operations Manager',
  img: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=300&auto=format&fit=crop&facepad=3&fit=facearea'
}, {
  name: 'Tom Williams',
  role: 'Senior Driver',
  img: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=300&auto=format&fit=crop&facepad=3&fit=facearea'
}, {
  name: 'Amara Osei',
  role: 'Customer Relations',
  img: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=300&auto=format&fit=crop&facepad=3&fit=facearea'
}];
const whyUs = [{
  icon: TrendingUp,
  title: 'Competitively Priced',
  desc: 'Fair, transparent pricing with no hidden fees. We beat most local quotes.'
}, {
  icon: Leaf,
  title: 'Eco-Friendly',
  desc: '90%+ recycling rate. We always choose the most sustainable disposal route.'
}, {
  icon: Shield,
  title: 'Fully Insured',
  desc: '£5M public liability insurance. Your property is always protected.'
}, {
  icon: Clock,
  title: 'Fast Same-Day Options',
  desc: 'Need it gone today? We offer same-day collections 7 days a week.'
}, {
  icon: Users,
  title: 'Community Focused',
  desc: 'Proudly serving Chingford, North London, East London & Enfield. We donate usable items to local charities.'
}, {
  icon: Heart,
  title: 'Long-Term Discounts',
  desc: 'Regular customers and contract clients receive preferential rates.'
}];
const testimonials = [{
  name: 'Rachel B.',
  location: 'Chingford',
  text: "Marcus and the team were absolutely fantastic. Cleared my late father's house with such sensitivity and professionalism. Cannot recommend highly enough.",
  rating: 5
}, {
  name: 'Ahmed K.',
  location: 'Wembley',
  text: 'Used them for our office move. Arrived on time, worked efficiently, and the price was very fair. Will definitely use again for our next move.',
  rating: 5
}, {
  name: 'Linda T.',
  location: 'Finchley',
  text: 'Quick response, turned up when they said they would, and cleared everything including items I thought would be a problem. Great service.',
  rating: 5
}];
const slogans = ['"Green, Clean, and Always on Time."', '"Your Rubbish, Our Responsibility."', '"Clearing London, One Load at a Time."', '"Eco-Friendly. Fully Insured. Always Reliable."'];
export function AboutPage() {
  return <div className="pt-16 lg:pt-20" data-id="element-208">
      {/* Hero */}
      <section className="relative py-24 px-4 overflow-hidden" style={{
      background: 'linear-gradient(135deg, #1B8F4B 0%, #0F5D2E 100%)'
    }} data-id="element-209">
        <div className="max-w-7xl mx-auto text-center" data-id="element-210">
          <p className="text-green-300 text-sm font-bold uppercase tracking-widest mb-3" data-id="element-211">
            Our Story
          </p>
          <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-5" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-212">
            About Universal Global Logistics
          </h1>
          <p className="text-green-100 text-xl max-w-3xl mx-auto" data-id="element-213">
            A family-founded waste removal company built on trust,
            eco-responsibility, and genuine care for our community.
          </p>
        </div>
      </section>

      {/* Story */}
      <section className="py-20 px-4 bg-white" data-id="element-214">
        <div className="max-w-7xl mx-auto" data-id="element-215">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-216">
            <div data-id="element-217">
              <p className="text-sm font-bold uppercase tracking-widest mb-3" style={{
              color: '#1B8F4B'
            }} data-id="element-218">
                How We Started
              </p>
              <h2 className="text-3xl font-bold text-gray-900 mb-5" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-219">
                Our Story
              </h2>
              <div className="space-y-4 text-gray-600 leading-relaxed" data-id="element-220">
                <p data-id="element-221">
                  Universal Global Logistics was founded in North London over 15
                  years ago by Marcus Johnson, a local man who saw a gap in the
                  market for a genuinely eco-conscious, community-focused waste
                  removal service.
                </p>
                <p data-id="element-222">
                  What started as a one-van operation has grown into a trusted
                  team serving the whole of Greater London — from single-item
                  collections to full commercial contracts with councils and
                  property managers.
                </p>
                <p data-id="element-223">
                  Our mission has never changed: to provide fast, reliable, and
                  environmentally responsible waste removal that our customers
                  can trust. We believe that doing the right thing for the
                  environment and doing right by our customers go hand in hand.
                </p>
                <p data-id="element-224">
                  Today, we're proud to have recycled over 847 tonnes of waste
                  this year alone, donated thousands of items to local
                  charities, and built lasting relationships with the
                  communities we serve.
                </p>
              </div>
            </div>
            <div className="relative" data-id="element-225">
              <img src="https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=700&auto=format&fit=crop" alt="Universal Global Logistics team at work" className="rounded-2xl shadow-xl w-full" data-id="element-226" />
              <div className="absolute -bottom-5 -left-5 bg-white rounded-2xl p-5 shadow-xl border border-gray-100" data-id="element-227">
                <p className="text-3xl font-extrabold" style={{
                color: '#1B8F4B',
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-228">
                  15+
                </p>
                <p className="text-sm text-gray-500" data-id="element-229">Years serving London</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission */}
      <section className="py-16 px-4 texture-paper" data-id="element-230">
        <div className="max-w-4xl mx-auto text-center" data-id="element-231">
          <Leaf className="w-12 h-12 mx-auto mb-4" style={{
          color: '#1B8F4B'
        }} data-id="element-232" />
          <h2 className="text-3xl font-bold text-gray-900 mb-4" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-233">
            Our Mission
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed italic" data-id="element-234">
            "To provide sustainable, safe, and community-focused waste removal
            services that make London cleaner, greener, and better for
            everyone."
          </p>
        </div>
      </section>

      {/* Team */}
      <section className="py-20 px-4 bg-white" data-id="element-235">
        <div className="max-w-7xl mx-auto" data-id="element-236">
          <div className="text-center mb-12" data-id="element-237">
            <h2 className="text-3xl font-bold text-gray-900" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-238">
              Meet the Team
            </h2>
            <p className="text-gray-500 mt-2" data-id="element-239">
              The people behind every collection.
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-240">
            {team.map(({
            name,
            role,
            img
          }) => <div key={name} className="text-center" data-id="element-241">
                <div className="w-24 h-24 rounded-full overflow-hidden mx-auto mb-3 border-4 border-white shadow-lg" data-id="element-242">
                  <img src={img} alt={name} className="w-full h-full object-cover" data-id="element-243" />
                </div>
                <h3 className="font-bold text-gray-900 text-sm" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-244">
                  {name}
                </h3>
                <p className="text-xs text-gray-500 mt-0.5" data-id="element-245">{role}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Accreditations */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-246">
        <div className="max-w-7xl mx-auto" data-id="element-247">
          <div className="text-center mb-10" data-id="element-248">
            <h2 className="text-3xl font-bold text-gray-900" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-249">
              Accreditations & Credentials
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-250">
            {[{
            icon: Award,
            title: 'Licensed Waste Carrier',
            detail: 'Environment Agency Registered',
            desc: 'Registered with the Environment Agency as an upper-tier waste carrier.'
          }, {
            icon: Shield,
            title: 'Fully Insured',
            detail: 'Comprehensive Coverage',
            desc: 'Comprehensive insurance covering all operations and your property.'
          }, {
            icon: Leaf,
            title: 'Recycling Commitment',
            detail: '90%+ recycling rate',
            desc: 'We divert the maximum possible waste from landfill on every single job.'
          }].map(({
            icon: Icon,
            title,
            detail,
            desc
          }) => <div key={title} className="bg-white rounded-2xl p-6 border border-gray-100 shadow-sm text-center" data-id="element-251">
                <div className="w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-4" style={{
              backgroundColor: '#F0FDF4'
            }} data-id="element-252">
                  <Icon className="w-7 h-7" style={{
                color: '#1B8F4B'
              }} data-id="element-253" />
                </div>
                <h3 className="font-bold text-gray-900 mb-1" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-254">
                  {title}
                </h3>
                <p className="text-sm font-semibold mb-2" style={{
              color: '#1B8F4B'
            }} data-id="element-255">
                  {detail}
                </p>
                <p className="text-sm text-gray-500" data-id="element-256">{desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 px-4 bg-white" data-id="element-257">
        <div className="max-w-7xl mx-auto" data-id="element-258">
          <div className="text-center mb-12" data-id="element-259">
            <h2 className="text-3xl font-bold text-gray-900" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-260">
              Why Choose Us?
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-261">
            {whyUs.map(({
            icon: Icon,
            title,
            desc
          }) => <div key={title} className="flex gap-4 p-5 rounded-2xl border border-gray-100 hover:shadow-md transition-all duration-300" data-id="element-262">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{
              backgroundColor: '#F0FDF4'
            }} data-id="element-263">
                  <Icon className="w-5 h-5" style={{
                color: '#1B8F4B'
              }} data-id="element-264" />
                </div>
                <div data-id="element-265">
                  <h3 className="font-bold text-gray-900 mb-1 text-sm" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-266">
                    {title}
                  </h3>
                  <p className="text-sm text-gray-500" data-id="element-267">{desc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Slogans */}
      <section className="py-16 px-4 texture-paper" data-id="element-268">
        <div className="max-w-4xl mx-auto text-center" data-id="element-269">
          <h2 className="text-2xl font-bold text-gray-900 mb-8" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-270">
            Our Brand Slogans
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-271">
            {slogans.map((slogan, i) => <div key={i} className={`p-5 rounded-2xl border-2 ${i === 0 ? 'border-[#1B8F4B] bg-green-50' : 'border-gray-200 bg-white'}`} data-id="element-272">
                <p className={`font-semibold italic ${i === 0 ? 'text-[#1B8F4B]' : 'text-gray-600'}`} style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-273">
                  {slogan}
                </p>
                {i === 0 && <span className="text-xs font-bold mt-2 inline-block" style={{
              color: '#1B8F4B'
            }} data-id="element-274">
                    ★ Primary Slogan
                  </span>}
              </div>)}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 px-4 bg-gray-50" data-id="element-275">
        <div className="max-w-7xl mx-auto" data-id="element-276">
          <div className="text-center mb-12" data-id="element-277">
            <h2 className="text-3xl font-bold text-gray-900" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-278">
              What People Say
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-279">
            {testimonials.map(({
            name,
            location,
            text,
            rating
          }) => <div key={name} className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100" data-id="element-280">
                <div className="flex gap-1 mb-3" data-id="element-281">
                  {[...Array(rating)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" style={{
                color: '#F59E0B'
              }} data-id="element-282" />)}
                </div>
                <p className="text-gray-700 text-sm leading-relaxed mb-4" data-id="element-283">
                  "{text}"
                </p>
                <div data-id="element-284">
                  <p className="font-bold text-gray-900 text-sm" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-285">
                    {name}
                  </p>
                  <p className="text-xs text-gray-400" data-id="element-286">{location}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      <CTAStrip data-id="element-287" />
    </div>;
}